export const messages = {
  en: {
    productPriceRule: {
      queryCondition: 'Query Conditions',
      productPricing: 'Product Pricing',
      strategyName: 'Strategy Name',
      sellingPrice: 'Selling Price',
      marketPrice: 'Market Price',
      memberPrice: 'Member Price',
      ownerPrice: 'Owner Price',
      propertyDeduction: 'Property Deduction',
      basedOn: 'Based on ',
      costPrice: 'Cost Price',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      pricing: 'Pricing',
      placeholderRuleId: 'Please enter strategy ID',
      placeholderRuleName: 'Please enter strategy name',
      requiredRuleName: 'Required, please enter strategy name',
      strategyType: 'Strategy Type',
      requiredRuleType: 'Required, please select strategy type',
      normal: 'Normal',
      supplyChain: 'Supply Chain',
      percentage: 'Percentage',
      requiredSelect: 'Required, please select',
      confirmOperation: 'Please confirm your operation',
      confirmDeletePriceRule: 'Confirm to delete product pricing rule',
      confirmDelete: 'Confirm Delete',
      selectProductCategory: 'Please select product category',
      inputProductName: 'Input product name',
      productName: 'Product Name',
      productCategory: 'Product Category',
      productId: 'Product ID',
      selectAtLeastOneProduct: 'Please select at least one product'
    }
  },
  zh: {
    productPriceRule: {
      queryCondition: '查询条件',
      productPricing: '商品定价',
      strategyName: '策略名称',
      sellingPrice: '销售价',
      marketPrice: '市场价',
      memberPrice: '会员价',
      ownerPrice: '业主价',
      propertyDeduction: '物业抵扣金',
      basedOn: '基于',
      costPrice: '成本价',
      add: '添加',
      edit: '修改',
      delete: '删除',
      pricing: '定价',
      placeholderRuleId: '请输入策略编号',
      placeholderRuleName: '请输入策略名称',
      requiredRuleName: '必填，请填写策略名称',
      strategyType: '策略类型',
      requiredRuleType: '必填，请选择策略类型',
      normal: '普通',
      supplyChain: '供应链',
      percentage: '百分之几',
      requiredSelect: '必填，请选择',
      confirmOperation: '请确认您的操作',
      confirmDeletePriceRule: '确定删除商品定价',
      confirmDelete: '确认删除',
      selectProductCategory: '请选择商品分组',
      inputProductName: '输入商品信息名称',
      productName: '商品名称',
      productCategory: '商品大类',
      productId: '商品编号',
      selectAtLeastOneProduct: '请至少选择一件商品'
    }
  }
}